import React, { Component } from 'react';
import { Col, DatePicker, Row, Select } from 'antd';
import moment from 'moment';

import YandexHeatMapWrap from './YandexHeatMapWrap';

import LoadingCss from '../../../components/LoadingCss';
import cubejs from '../../../cube';

const { Option } = Select;
const cubejsApi = cubejs({ appId: 1 });

export default class AppealsMap extends Component {
  state = {
    range: [moment().subtract(30, 'd').startOf('day'), moment()],
    data: [],
    filtersData: {
      'Appeals.category': {
        key: 'Appeals.category',
        title: 'Категория',
        options: [],
        values: [],
      },
      'Appeals.subCategory': {
        key: 'Appeals.subCategory',
        title: 'Подкатегория',
        options: [],
        values: [],
      },
      'Appeals.status': {
        key: 'Appeals.status',
        title: 'Статус',
        options: [],
        values: [],
      },
      'Appeals.region': {
        key: 'Appeals.region',
        title: 'Регион',
        options: [],
        values: [],
      },
      'Appeals.district': {
        key: 'Appeals.district',
        title: 'Населенный пункт',
        options: [],
        values: [],
      },
      'Appeals.expired': {
        key: 'Appeals.expired',
        title: 'Просроченные',
        options: [],
        values: [],
      },
    },
    loading: true,
  };

  async componentDidMount() {
    let { filtersData } = this.state;
    const filterNames = Object.keys(filtersData);
    const reqs = filterNames.map((f) => cubejsApi.load({ dimensions: [f] }));
    const responses = await Promise.all(reqs);

    responses.forEach((res, i) => {
      filtersData = {
        ...filtersData,
        [filterNames[i]]: {
          ...filtersData[filterNames[i]],
          options: res.rawData().map((d) => d[filterNames[i]]),
        },
      };
    });
    this.setState({ filtersData });
    this.getData();
  }

  getData = () => {
    const { filtersData } = this.state;
    let filters = [];
    const filterNames = Object.keys(filtersData);
    filterNames.forEach((f) => {
      const filter = filtersData[f];
      if (filter.values.length) {
        filters = [
          ...filters,
          {
            member: f,
            operator: 'equals',
            values: filter.values.map((f) => f.toString()),
          },
        ];
      }
    });

    let query = {
      dimensions: [
        'Appeals.id',
        'Appeals.x',
        'Appeals.y',
        'Appeals.plannedDate',
        'Appeals.replyDate',
      ],
      filters: [
        {
          member: 'Appeals.submissionDate',
          operator: 'inDateRange',
          values: this.state.range,
        },
        {
          member: 'Appeals.x',
          operator: 'set',
        },
        {
          member: 'Appeals.y',
          operator: 'set',
        },
        ...filters,
      ],
    };

    this.setState({ loading: true });

    cubejsApi
      .load(query)
      .then((r) => {
        let data = r.rawData();
        data = data.map((e) => ({
          ...e,
          'Appeals.x': e['Appeals.x'].toString().substring(0, 10),
          'Appeals.y': e['Appeals.y'].toString().substring(0, 10),
        }));
        this.setState({ data });
      })
      .catch(() => {})
      .finally(() => {
        this.setState({ loading: false });
      });
  };
  handleRange = (val) => {
    this.setState({ range: val }, this.getData);
  };

  applyFilters = (filter, values) => {
    let { filtersData } = this.state;
    this.setState(
      {
        filtersData: {
          ...filtersData,
          [filter]: {
            ...filtersData[filter],
            values,
          },
        },
        loading: true,
      },
      () => this.getData()
    );
  };

  render() {
    const { filtersData, loading } = this.state;
    const filterNames = Object.keys(filtersData);
    return (
      <div>
        <Row style={{ marginBottom: '10px' }}>
          <Col span={4}>
            <h4>Период</h4>
            <DatePicker.RangePicker
              onChange={this.handleRange}
              value={this.state.range}
              size="small"
              separator="-"
              style={{ width: '97%' }}
            />
          </Col>
          {filterNames.map((f, i) => {
            const filter = filtersData[f];
            return (
              <Col span={4} key={i}>
                <h4>{filter.title}</h4>
                <Select
                  mode="multiple"
                  onChange={(value) => this.applyFilters(filter.key, value)}
                  size="small"
                  allowClear
                  style={{ width: '97%' }}
                >
                  {filter.options.map((val) => (
                    <Option value={val} key={val}>
                      {val}
                    </Option>
                  ))}
                </Select>
              </Col>
            );
          })}
        </Row>
        <Row>
          <Col span={24}>
            {loading ? (
              <LoadingCss />
            ) : (
              <YandexHeatMapWrap
                objects={this.state.data}
                showDefaultCity
                idDataKey="Appeals.id"
                xDataKey="Appeals.y"
                yDataKey="Appeals.x"
                handleClick={() => {}}
                height="70vh"
              />
            )}
          </Col>
        </Row>
      </div>
    );
  }
}
